import { useDeviceType } from '@cian/ui-kit';
import { ActionButton } from 'shared/components/ActionButton';
import { ITEMS } from './constants';
import * as styles from './styles.css';
import clsx from 'clsx';

export const BonusUsageSection: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Используйте бонусы для продвижения</div>
      <div className={styles['list']}>
        {ITEMS.map(({ id, title, stepClass, imageClass }) => (
          <div key={id} className={clsx(styles[stepClass], styles['item'])}>
            <div className={styles['item-title']}>{title}</div>
            <div className={clsx(styles['image'], styles[imageClass])} />
          </div>
        ))}
      </div>
      <ActionButton>Разместить</ActionButton>
    </div>
  );
};
